
        var result = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js!./Tag.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./packages/tag/Tag.scss
// module id = 39
// module chunks = 1 2